// extracted by mini-css-extract-plugin
export var row = "_vp-0";